import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { Location } from 'features/inventory/locations/types';
import { warehouseService } from 'features/inventory/warehouses/api/warehouse.service';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';

interface LaboratoryFormParams {
  location: Location;
  onSubmit: any;
  disableEdit?: boolean;
}

function LocationForm({ location, onSubmit, disableEdit }: LaboratoryFormParams) {
  const { t } = useTranslation();

  const [warehouses, setWarehouses] = useState<Option[]>([]);

  useEffect(() => {
    warehouseService.getAllBaseInformation().then(setWarehouses);
  }, []);

  return (
    <div>
      {location && (
        <EnhancedForm onSubmit={onSubmit} edit={!!location.id}>
          <div className="flex flex-wrap">
            <div className="w-full md:w-1/3 p-2">
              <IdentityField
                name="code"
                initialValue={location.code}
                component={TextFieldAdapter}
                label={t('global.code')}
                type="text"
                validate={required}
                disabled={disableEdit}
              />
            </div>
            <div className="w-full md:w-2/3 p-2">
              <IdentityField
                name="description"
                initialValue={location.description}
                component={TextFieldAdapter}
                label={t('global.description')}
                type="text"
                validate={required}
                disabled={disableEdit}
              />
            </div>
            <div className="w-full my-4">
              {warehouses && (
                <IdentityField
                  name="warehouse"
                  component={AutocompleteAdapter}
                  initValue={warehouses.find((s) => s.id === location.warehouse)}
                  defaultValue={location.warehouse}
                  options={warehouses}
                  optionlabel="id"
                  label={t('global.warehouse')}
                  type="text"
                  disabled={disableEdit}
                />
              )}
            </div>
          </div>
        </EnhancedForm>
      )}
    </div>
  );
}

export default LocationForm;
